export default __webpack_public_path__ + "static/media/ic-timer.40ce534d.svg";